<template>
  <div>
    <v-progress-linear indeterminate color="purple" class="mb-2" v-if="cargando" />

    <ag-grid-vue
      :gridOptions="gridOptions"
      class="ag-theme-balham ag-grid-table-presupuestos-consolidados"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      :rowData="presupuestos"
      rowSelection="single"
      colResizeDefault="shift"
      :animateRows="false"
      :floatingFilter="true"
      :pagination="false"
      :pinnedBottomRowData="pinnedBottomRowData"
      :alwaysShowVerticalScroll="true"
      :suppressPaginationPanel="true"
      @first-data-rendered="onFirstDataRendered"
      @grid-ready="onGridReady">
    </ag-grid-vue>
  </div>
</template>
  
<script>
import ListadoAgGridMixin from '../mixins/listado-ag-grid-mixin';
import { formatearValorAMoneda, TIPOS_PRESUPUESTOS_CONSOLIDADOS } from '../utils';

export default {
  name: 'ListadoPresupuestosAgrupadosConsolidados',
  mixins: [ListadoAgGridMixin],
  props: {
    tipo: {
      type: String,
      required: true,
      validator: (value) => {
        return [
          TIPOS_PRESUPUESTOS_CONSOLIDADOS.GASTO_POR_GRUPO,
          TIPOS_PRESUPUESTOS_CONSOLIDADOS.GASTO_POR_GRUPO_POR_MESES,
        ].includes(value);
      },
    },
  },
  created() {
    const columnaGrupo =
      this.tipo === TIPOS_PRESUPUESTOS_CONSOLIDADOS.GASTO_POR_GRUPO
        ? this.columnaGrupoAgrupado
        : this.columnaGrupoAgrupadoPorMeses;

    this.columnDefs.splice(2, 0, columnaGrupo);
  },
  computed: {
    pinnedBottomRowData() {
      return [
        this.tipo === TIPOS_PRESUPUESTOS_CONSOLIDADOS.GASTO_POR_GRUPO
          ? this.obtenerTotales()
          : this.obtenerTotalesPorMeses(),
      ];
    },
    presupuestosAgrupados() {
      const presupuestosAgrupados = {};

      this.items.forEach((presupuesto) => {
        if (!presupuestosAgrupados[presupuesto.codigo_grupo_padre]) {
          presupuestosAgrupados[presupuesto.codigo_grupo_padre] = {
            codigo_grupo_padre: presupuesto.codigo_grupo_padre,
            grupo_padre: presupuesto.grupo_padre,
            total_grupo_padre: 0,
            grupos: [],
          };
        }

        presupuestosAgrupados[presupuesto.codigo_grupo_padre].grupos.push({
          codigo_grupo: presupuesto.codigo_grupo,
          grupo: presupuesto.grupo,
          enero: Number(presupuesto.enero),
          febrero: Number(presupuesto.febrero),
          marzo: Number(presupuesto.marzo),
          abril: Number(presupuesto.abril),
          mayo: Number(presupuesto.mayo),
          junio: Number(presupuesto.junio),
          julio: Number(presupuesto.julio),
          agosto: Number(presupuesto.agosto),
          septiembre: Number(presupuesto.septiembre),
          octubre: Number(presupuesto.octubre),
          noviembre: Number(presupuesto.noviembre),
          diciembre: Number(presupuesto.diciembre),
          total_grupo: Number(presupuesto.total_grupo),
        });

        presupuestosAgrupados[presupuesto.codigo_grupo_padre].total_grupo_padre += Number(presupuesto.total_grupo);
      });

      return presupuestosAgrupados;
    },
    presupuestos() {
      return Object.values(this.presupuestosAgrupados);
    },
  },
  data() {
    return {
      columnaGrupoAgrupado: {
        headerName: 'GRUPO',
        headerComponentParams: {
          template: /* html*/ `<table width="100%" style="border-collapse">
                  <tr>
                      <th style="font-size: 13px; font-weight: 600; width: 800px;">GRUPO</th>
                      <th style="font-size: 13px; font-weight: 600; width: 150px; text-align: right;">TOTAL GRUPO</th>
                  </tr>
              </table>`,
        },
        cellRenderer: (params) => {
          if (params.node.rowPinned) {
            return params.data.grupos;
          }

          let detalle = /* html*/ `
              <table width="100%" style="border-collapse: collapse;">`;
          const grupos = params.data.grupos || [];

          for (let i = 0; i < grupos.length; i++) {
            const grupo = grupos[i];

            detalle += /* html*/ `
                <tr>
                    <td style="width: 300px; max-width: 300px; overflow-x: hidden;">
                        ${grupo.codigo_grupo} ${grupo.grupo}
                    </td>
                    <td style="width: 150px; max-width: 150px; overflow-x: hidden; text-align: right;">
                        ${formatearValorAMoneda(grupo.total_grupo)}
                    </td>
                </tr>`;
          }

          detalle += /* html*/ `
              </table>`;

          return detalle;
        },
        autoHeight: true,
        suppressSizeToFit: true,
        filter: true,
        minWidth: 950,
        maxWidth: 950,
      },

      columnaGrupoAgrupadoPorMeses: {
        headerName: 'GRUPO',
        headerComponentParams: {
          template: /* html*/ `<table width="100%" style="border-collapse">
                  <tr>
                      <th style="font-size: 13px; font-weight: 600; width: 300px;">GRUPO</th>
                      <th style="font-size: 13px; font-weight: 600; width: 150px; text-align: right;">ENERO</th>
                      <th style="font-size: 13px; font-weight: 600; width: 150px; text-align: right;">FEBRERO</th>
                      <th style="font-size: 13px; font-weight: 600; width: 150px; text-align: right;">MARZO</th>
                      <th style="font-size: 13px; font-weight: 600; width: 150px; text-align: right;">ABRIL</th>
                      <th style="font-size: 13px; font-weight: 600; width: 150px; text-align: right;">MAYO</th>
                      <th style="font-size: 13px; font-weight: 600; width: 150px; text-align: right;">JUNIO</th>
                      <th style="font-size: 13px; font-weight: 600; width: 150px; text-align: right;">JULIO</th>
                      <th style="font-size: 13px; font-weight: 600; width: 150px; text-align: right;">AGOSTO</th>
                      <th style="font-size: 13px; font-weight: 600; width: 150px; text-align: right;">SEPTIEMBRE</th>
                      <th style="font-size: 13px; font-weight: 600; width: 150px; text-align: right;">OCTUBRE</th>
                      <th style="font-size: 13px; font-weight: 600; width: 150px; text-align: right;">NOVIEMBRE</th>
                      <th style="font-size: 13px; font-weight: 600; width: 150px; text-align: right;">DICIEMBRE</th>
                      <th style="font-size: 13px; font-weight: 600; width: 150px; text-align: right;">TOTAL GRUPO</th>
                  </tr>
              </table>`,
        },
        cellRenderer: (params) => {
          if (params.node.rowPinned) {
            return params.data.grupos;
          }

          let detalle = /* html*/ `
              <table width="100%" style="border-collapse: collapse;">`;
          const grupos = params.data.grupos || [];

          for (let i = 0; i < grupos.length; i++) {
            const grupo = grupos[i];

            detalle += /* html*/ `
                <tr>
                    <td style="width: 300px; max-width: 300px; overflow-x: hidden;">
                        ${grupo.codigo_grupo} ${grupo.grupo}
                    </td>
                    <td style="width: 150px; max-width: 150px; overflow-x: hidden; text-align: right;">
                        ${formatearValorAMoneda(grupo.enero)}
                    </td>
                    <td style="width: 150px; max-width: 150px; overflow-x: hidden; text-align: right;">
                        ${formatearValorAMoneda(grupo.febrero)}
                    </td>
                    <td style="width: 150px; max-width: 150px; overflow-x: hidden; text-align: right;">
                        ${formatearValorAMoneda(grupo.marzo)}
                    </td>
                    <td style="width: 150px; max-width: 150px; overflow-x: hidden; text-align: right;">
                        ${formatearValorAMoneda(grupo.abril)}
                    </td>
                    <td style="width: 150px; max-width: 150px; overflow-x: hidden; text-align: right;">
                        ${formatearValorAMoneda(grupo.mayo)}
                    </td>
                    <td style="width: 150px; max-width: 150px; overflow-x: hidden; text-align: right;">
                        ${formatearValorAMoneda(grupo.junio)}
                    </td>
                    <td style="width: 150px; max-width: 150px; overflow-x: hidden; text-align: right;">
                        ${formatearValorAMoneda(grupo.julio)}
                    </td>
                    <td style="width: 150px; max-width: 150px; overflow-x: hidden; text-align: right;">
                        ${formatearValorAMoneda(grupo.agosto)}
                    </td>
                    <td style="width: 150px; max-width: 150px; overflow-x: hidden; text-align: right;">
                        ${formatearValorAMoneda(grupo.septiembre)}
                    </td>
                    <td style="width: 150px; max-width: 150px; overflow-x: hidden; text-align: right;">
                        ${formatearValorAMoneda(grupo.octubre)}
                    </td>
                    <td style="width: 150px; max-width: 150px; overflow-x: hidden; text-align: right;">
                        ${formatearValorAMoneda(grupo.noviembre)}
                    </td>
                    <td style="width: 150px; max-width: 150px; overflow-x: hidden; text-align: right;">
                        ${formatearValorAMoneda(grupo.diciembre)}
                    </td>
                    <td style="width: 150px; max-width: 150px; overflow-x: hidden; text-align: right;">
                        ${formatearValorAMoneda(grupo.total_grupo)}
                    </td>
                </tr>`;
          }

          detalle += /* html*/ `
              </table>`;

          return detalle;
        },
        autoHeight: true,
        suppressSizeToFit: true,
        filter: true,
        minWidth: 2250,
        maxWidth: 2250,
      },
      columnDefs: [
        {
          headerName: 'GRUPO PADRE',
          cellRenderer: (params) => {
            return `${params.data.codigo_grupo_padre} ${params.data.grupo_padre}`;
          },
          filter: true,
          checkboxSelection: true,
          minWidth: 260,
        },
        {
          headerName: 'TOTAL GRUPO PADRE',
          cellRenderer: (params) => {
            return formatearValorAMoneda(params.data.total_grupo_padre);
          },
          filter: false,
          type: 'numericColumn',
          minWidth: 150,
          maxWidth: 150,
        },
      ],
    };
  },
  methods: {
    obtenerTotales() {
      let total_grupo = 0;

      this.items.forEach((item) => {
        total_grupo += parseFloat(item.total_grupo);
      });

      return {
        total_grupo_padre: this.presupuestos.reduce((a, b) => a + Number(b.total_grupo_padre), 0),
        codigo_grupo_padre: '',
        grupo_padre: 'TOTALES',
        grupos: /* html*/ `<table>
          <tr>
            <td style="width: 800px; max-width: 800px; overflow-x: hidden;"></td>
            <td style="width: 150px; max-width: 150px; overflow-x: hidden; text-align: right;">${formatearValorAMoneda(
              total_grupo,
            )}</td>
          </tr>
        </table>`,
      };
    },
    obtenerTotalesPorMeses() {
      const totales = {
        enero: 0,
        febrero: 0,
        marzo: 0,
        abril: 0,
        mayo: 0,
        junio: 0,
        julio: 0,
        agosto: 0,
        septiembre: 0,
        octubre: 0,
        noviembre: 0,
        diciembre: 0,
        total_grupo: 0,
      };

      this.items.forEach((item) => {
        totales.enero += parseFloat(item.enero);
        totales.febrero += parseFloat(item.febrero);
        totales.marzo += parseFloat(item.marzo);
        totales.abril += parseFloat(item.abril);
        totales.mayo += parseFloat(item.mayo);
        totales.junio += parseFloat(item.junio);
        totales.julio += parseFloat(item.julio);
        totales.agosto += parseFloat(item.agosto);
        totales.septiembre += parseFloat(item.septiembre);
        totales.octubre += parseFloat(item.octubre);
        totales.noviembre += parseFloat(item.noviembre);
        totales.diciembre += parseFloat(item.diciembre);
        totales.total_grupo += parseFloat(item.total_grupo);
      });

      return {
        total_grupo_padre: this.presupuestos.reduce((a, b) => a + Number(b.total_grupo_padre), 0),
        codigo_grupo_padre: '',
        grupo_padre: 'TOTALES',
        grupos: /* html*/ `<table>
          <tr>
            <td style="width: 300px; max-width: 300px; overflow-x: hidden;"></td>
            <td style="width: 150px; max-width: 150px; overflow-x: hidden; text-align: right;">${formatearValorAMoneda(
              totales.enero,
            )}</td>
            <td style="width: 150px; max-width: 150px; overflow-x: hidden; text-align: right;">${formatearValorAMoneda(
              totales.febrero,
            )}</td>
            <td style="width: 150px; max-width: 150px; overflow-x: hidden; text-align: right;">${formatearValorAMoneda(
              totales.marzo,
            )}</td>
            <td style="width: 150px; max-width: 150px; overflow-x: hidden; text-align: right;">${formatearValorAMoneda(
              totales.abril,
            )}</td>
            <td style="width: 150px; max-width: 150px; overflow-x: hidden; text-align: right;">${formatearValorAMoneda(
              totales.mayo,
            )}</td>
            <td style="width: 150px; max-width: 150px; overflow-x: hidden; text-align: right;">${formatearValorAMoneda(
              totales.junio,
            )}</td>
            <td style="width: 150px; max-width: 150px; overflow-x: hidden; text-align: right;">${formatearValorAMoneda(
              totales.julio,
            )}</td>
            <td style="width: 150px; max-width: 150px; overflow-x: hidden; text-align: right;">${formatearValorAMoneda(
              totales.agosto,
            )}</td>
            <td style="width: 150px; max-width: 150px; overflow-x: hidden; text-align: right;">${formatearValorAMoneda(
              totales.septiembre,
            )}</td>
            <td style="width: 150px; max-width: 150px; overflow-x: hidden; text-align: right;">${formatearValorAMoneda(
              totales.octubre,
            )}</td>
            <td style="width: 150px; max-width: 150px; overflow-x: hidden; text-align: right;">${formatearValorAMoneda(
              totales.noviembre,
            )}</td>
            <td style="width: 150px; max-width: 150px; overflow-x: hidden; text-align: right;">${formatearValorAMoneda(
              totales.diciembre,
            )}</td>
            <td style="width: 150px; max-width: 150px; overflow-x: hidden; text-align: right;">${formatearValorAMoneda(
              totales.total_grupo,
            )}</td>
          </tr>
        </table>`,
      };
    },
  },
};
</script>

<style>
@import '~ag-grid-community/dist/styles/ag-grid.css';
@import '~ag-grid-community/dist/styles/ag-theme-balham.css';
@import './../css/styles.css';

.ag-grid-table-presupuestos-consolidados {
  height: calc(var(--vh, 1vh) * 100 - 19.5rem);
}

.ag-header-group-cell-label {
  justify-content: center !important;
}
</style>